var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKontaktMen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    "data-name": "Ebene 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 703.66 628.33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: #ffe7c9;\n      }\n\n      .cls-3 {\n        fill: #ffc96a;\n      }\n\n      .cls-4 {\n        fill: #ffc5a8;\n      }\n\n      .cls-5 {\n        fill: #fcc98b;\n      }\n\n      .cls-6 {\n        fill: #fcb795;\n      }\n\n      .cls-7 {\n        fill: #80c3ff;\n      }\n\n      .cls-8 {\n        fill: #dbe2ed;\n      }\n\n      .cls-9 {\n        fill: #25385e;\n      }\n\n      .cls-10 {\n        fill: #3fcce8;\n      }\n\n      .cls-11 {\n        fill: #355187;\n      }\n\n      .cls-12 {\n        fill: #4367ab;\n      }\n\n      .cls-13 {\n        fill: #4e78c7;\n      }\n\n      .cls-14 {\n        fill: #2c2334;\n        opacity: .16;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_5",
    "data-name": "Layer 5"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    y: 390.35,
    width: 432.94,
    height: 237.98
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m526.43,30.1l-40.81-8.31c-5.96-1.21-9.8-7.03-8.59-12.98h0c1.21-5.96,7.03-9.8,12.98-8.59l40.81,8.31c5.96,1.21,9.8,7.03,8.59,12.98h0c-1.21,5.96-7.03,9.8-12.98,8.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m487.59,22.98h50.9v30.87c0,9.47-7.69,17.16-17.16,17.16h-33.74V22.98h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m523.23,201.82c-9.72,18.74-32.79,26.04-51.53,16.33l-68.12-35.07-5.92-3.04-59.24-30.49c-18.74-9.72-26.04-32.79-16.33-51.53,4.42-8.51,11.58-14.67,19.85-17.95,8.2-3.25,17.45-3.65,26.19-.7,1.87.6,3.7,1.39,5.5,2.32l33.41,17.19,99.87,51.41c18.74,9.72,26.04,32.79,16.31,51.54Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "390.33 176.26 395.7 152.5 403.58 183.08 390.33 176.26"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m482.14,66.25s-1.39,5.42-3.5,14.04c-6.43,26.21-19.51,81.94-20.39,104.03-.95,24.09,15.17,37.87,35.72,38.68,2.92.12,5.78-.1,8.53-.63,16.54-3.17,29.34-17.36,30.15-34.89,0-.06,0-.14,0-.2l-1.97-119.09-48.55-1.94Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 495.17,
    cy: 65.56,
    rx: 19.37,
    ry: 18.57
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m482.14,66.25s-1.39,5.42-3.5,14.04c4.48,13.66,10.17,31.68,16.71,53.83,8.74,29.67,24.53,45.27,37.3,53.36,0-.06,0-.14,0-.2l-1.97-119.09-48.55-1.94Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m635.15,453.07l-81.44,52.66s-89.52-95.05-134.9-148.08c-6.78-7.91-12.98-15.31-18.53-22.3-23.35-29.42-34.97-51.59-28.1-74.51,2.42-8.12,7.15-16.32,14.49-24.97.74-.86,1.5-1.72,2.28-2.56,7.44-8.04,16.11-13.96,25.42-17.89l.16-.06c18.08-7.56,38.47-7.56,56.62-.66,15.97,6.05,30.19,17.46,39.56,33.72l124.44,204.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m703.66,463.23l-125.12,80.9-24.83-38.4,81.43-52.65s24.44,7.37,41.92.12c15.86-6.58,26.6,10.03,26.6,10.03Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m509.58,384.55l-53.95,150.29-17.14,47.76h-96.98l22.73-202.89c-8.04-29.31,1.84-58.4,21.93-77.13,13.65-12.73,32.02-20.68,52.68-20.68,1.15,0,2.28.02,3.4.08,51.02,2.21,84.55,54.5,67.32,102.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m485.99,628.33h-149l4.52-45.73h96.97s14.6,19.46,32.88,22.86c16.59,3.09,14.63,22.86,14.63,22.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m400.22,132.55l-11.72,51.8-3.92,17.35-18.15,80.19h-172.85l14.16-60.63,13.25-56.76,12.24-52.39c1.61-6.87,4.73-13.05,8.96-18.23,5.59-6.84,13.09-11.92,21.62-14.53.03-.02.08-.03.11-.03,3.98-1.22,8.18-1.89,12.49-1.94.2-.02.41-.02.61-.02h79.42c13.44,0,25.25,5.81,33.38,14.86,9.43,10.46,13.94,25.22,10.41,40.33Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "278.79 209.6 224.61 148.98 218.56 174.91 278.79 209.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "331.27 174.91 293.39 77.37 349.72 77.37 331.27 174.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m436.77,396.06h-191.95c-43.62,0-74.3-41.7-62.02-83.56l10.78-30.61h243.19v114.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m509.58,384.55l-53.95,150.29c-12.4-8.49-23.53-20.44-27.8-36.94-11.68-45.22,17.14-83.24-26.42-101.83-43.56-18.59-24.76-70.23-24.76-70.23l9.53-23.27c13.65-12.73,32.02-20.68,52.68-20.68,1.15,0,2.28.02,3.4.08,51.02,2.21,84.55,54.5,67.32,102.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m479.14,272.54l-78.86,62.81-76.19,60.72h-83.02c-9.47,0-18.3-2.07-26.18-5.72-27.73-12.89-43.48-45.55-32.39-76.99l11.07-31.46,220.79-66.48.16-.06,31.61,27.96,33,29.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m471.14,214.7c-5.6,9.14-13.82,19.92-25.01,28.62-10.6,8.26-23.88,14.59-40.11,15.82-13.3,1-24.27,1.07-33.84,1.7-28.82,1.93-44.99,9.08-74.67,62.95-22.73,41.26-57.31,58.97-82.61,66.56-27.73-12.89-43.48-45.55-32.39-76.99l11.07-31.46,220.79-66.48.16-.06c18.08-7.56,38.47-7.56,56.62-.66Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 311.13,
    y: 332.75,
    width: 182.42,
    height: 3.6,
    transform: "translate(-120.9 330.1) rotate(-39.26)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "330.61 98.56 302.85 77.51 318.26 25.96 349.18 32.75 330.61 98.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m358.44,29.99v.32c0,1.44-.15,2.91-.47,4.37-1.44,6.62-5.99,11.76-11.76,14.28-3.79,1.65-8.11,2.18-12.46,1.22-1.13-.24-2.21-.58-3.26-1.01-9.03-3.64-14.39-13.36-12.22-23.21,2.4-10.96,13.25-17.9,24.21-15.48,6.1,1.33,10.94,5.27,13.62,10.38,1.46,2.78,2.29,5.89,2.35,9.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m358.52,54.76c.02,1.14-.19,2.25-.56,3.26-1.63,4.39-6.51,7.39-11.3,6.34l-15.63-3.43-.54-11.76-.94-20.62,9.81.49,19.08.96v.32l.08,24.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m358.52,54.76c.02,1.14-.19,2.25-.56,3.26-1.11.17-2.44-.19-4.03-1.24-3.23-2.12-5.74-4.84-7.71-7.82-4.65-6.94-6.27-15.2-6.85-19.93-.28-2.35-.3-3.83-.3-3.83l17.04-4.35c1.46,2.78,2.29,5.89,2.35,9.14v.32l.08,24.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m358.05,26.34h-15.44c-6.38-.09-6.8,9.9-14.75,13.37-6.55,2.86-12.2,2.72-14.47,2.5l4.86-16.23c2.41-10.97,13.25-17.91,24.21-15.5,8.11,1.78,13.93,7.67,15.58,15.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m335.21,39.15c-.79,3.59-4.34,5.87-7.94,5.08-3.6-.79-5.87-4.34-5.08-7.94s4.34-5.87,7.94-5.08c3.6.79,5.87,4.34,5.08,7.94Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "357.75 47.1 354.71 47.1 354.71 46.02 356.67 46.02 356.67 42.31 357.75 42.31 357.75 47.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m354.71,54.89c-3.41,0-5.71-3.1-5.8-3.24l.87-.63s2.07,2.79,4.93,2.79v1.08Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m380.93,36.69c0,1.99-.55,3.82-1.54,5.4-.65,1.07-1.5,2-2.5,2.76-.08.07-.16.14-.24.19v1.94h-4.04c-3.7,0-6.96-1.96-8.77-4.89-.97-1.57-1.54-3.42-1.54-5.4,0-5.69,4.62-10.29,10.31-10.29h4.04v1.95c.08.05.16.12.24.19,2.46,1.88,4.04,4.84,4.04,8.16Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-11",
    cx: 376.65,
    cy: 36.69,
    r: 10.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 376.89,
    y: 26.41,
    width: 35.75,
    height: 20.57
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m399.95,42.09v4.89h-27.33c-3.7,0-6.96-1.96-8.77-4.89h36.1Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m419.61,36.69c0,2.98-.83,5.73-2.31,8.1-.97,1.6-2.25,3-3.75,4.13-.12.1-.24.2-.36.28v2.92h-6.06c-5.55,0-10.43-2.94-13.15-7.33-1.46-2.35-2.31-5.13-2.31-8.1,0-8.53,6.93-15.44,15.46-15.44h6.06v2.92c.12.08.24.18.36.28,3.69,2.82,6.06,7.25,6.06,12.24Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-11",
    cx: 413.19,
    cy: 36.69,
    r: 15.45,
    transform: "translate(95.08 302.92) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 413.55,
    y: 21.27,
    width: 53.62,
    height: 30.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m448.13,44.79v7.33h-41c-5.55,0-10.43-2.94-13.15-7.33h54.15Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m468.74,37.72c0,4.45-1.49,8.53-4.01,11.8-1.04,1.4-2.29,2.64-3.67,3.7-.14.12-.29.23-.45.34v3.7h-7.67c-6.35,0-12-3.04-15.56-7.74-2.49-3.28-3.97-7.37-3.97-11.8,0-10.79,8.75-19.52,19.54-19.52h7.67v3.7c.15.11.31.21.45.34,4.67,3.56,7.67,9.16,7.67,15.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m480.16,37.72c0,4.44-1.49,8.52-3.97,11.8-3.47,4.59-8.95,7.6-15.12,7.72-.15.02-.29.02-.45.02-6.35,0-12-3.04-15.56-7.74-2.49-3.28-3.97-7.37-3.97-11.8,0-10.79,8.75-19.52,19.54-19.52.15,0,.29,0,.45.02h.06c10.56.26,19.03,8.89,19.03,19.51Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 461.06,
    y: 18.21,
    width: 120.49,
    height: 39.04
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m591.26,37.72c0-6.52-3.21-12.28-8.12-15.83v-3.7h-7.67c-10.79,0-19.53,8.75-19.53,19.53s8.75,19.53,19.53,19.53h7.67v-3.7c4.91-3.55,8.12-9.31,8.12-15.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m583.14,49.52v7.74h-122.07v-.02c-.15.02-.29.02-.45.02h-7.67c-6.35,0-12-3.04-15.56-7.74h145.75Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 583.14,
    cy: 37.72,
    r: 19.53
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m598.08,37.72c0,8.26-6.69,14.94-14.94,14.94h-.09c-8.21-.05-14.86-6.71-14.86-14.94,0-7.2,5.09-13.21,11.87-14.63,1-.2,2.02-.31,3.08-.31,8.26,0,14.94,6.69,14.94,14.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m594.92,38.03c0,7.2-5.09,13.21-11.87,14.63-8.21-.05-14.86-6.71-14.86-14.94,0-7.2,5.09-13.21,11.87-14.63,8.22.05,14.86,6.71,14.86,14.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m583.31,28.21c1.33,2.29-.04,5.56-3.05,7.32-3.02,1.75-6.54,1.32-7.87-.96-1.33-2.29.04-5.56,3.05-7.32,3.02-1.75,6.54-1.32,7.87.96Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m499.78,81.89c-.72,0-1.44-.1-2.16-.32-.76-.23-18.83-5.74-28.72-18.14-9.89-12.39-10.18-22.19-10.18-23.27h15.08v-.19c0,.24.38,5.9,6.88,14.05,6.87,8.61,21.11,13.05,21.25,13.09,3.99,1.19,6.26,5.4,5.06,9.39-.98,3.27-3.98,5.38-7.22,5.38Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m423.17,25.56l17.51,53.01c1.47,4.43-1.17,9.25-5.85,10.3-3.32.75-6.62-.82-8.45-3.58-.41-.62-.75-1.3-.99-2.04-.62-1.87-3.02-2.42-4.39-.97l-20.08,21.22-2.11,2.24-.72.75-36.24-34.28,6.94-7.34,2.24-2.38,2.6-2.75s13.58-14.35,15.6-16.5l7.21-7.61c16.02-17.36,25.43-14.02,26.73-10.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m400.4,104.04s-2.98,4.91-7.81,12.64c-14.65,23.52-46.2,73.12-61.8,89.6-17.02,17.98-38.7,16.02-54.04,1.51-2.18-2.06-4.07-4.32-5.66-6.72-9.54-14.43-8.3-34.01,4.01-47.17.04-.05.1-.1.14-.15l88.9-83.98,36.26,34.27Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m400.4,104.04s-2.98,4.91-7.81,12.64c-13.24,6.51-30.57,15.25-51.53,26.34-28.06,14.86-50.85,14.46-65.96,10.88.04-.05.1-.1.14-.15l88.9-83.98,36.26,34.27Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKontaktMen);
export default __webpack_public_path__ + "static/media/kontakt-men.e81a72e1c17af7a002a54e01360ccfac.svg";
export { ForwardRef as ReactComponent };